import React, { createContext, useState } from "react";
import { AppLocale, GenerateLocales } from "@hrk/types";

export interface ILocaleContext {
  selectedLocale: AppLocale;
  setSelectedLocale: (newLocale: AppLocale) => void;
}

const defaultContext: ILocaleContext = {
  selectedLocale: GenerateLocales.de,
  setSelectedLocale: () => {
    return;
  },
};

export const LocaleContext = createContext<ILocaleContext>(defaultContext);

export const LocaleContextProvider = (props: { children: JSX.Element; pageContextLocale: AppLocale }): JSX.Element => {
  const [selectedLocale, setSelectedLocale] = useState<AppLocale>(props.pageContextLocale);

  return (
    <LocaleContext.Provider value={{ selectedLocale, setSelectedLocale }}>
      <>{props.children}</>
    </LocaleContext.Provider>
  );
};
